"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CreateSecurityRole = /** @class */ (function () {
    function CreateSecurityRole() {
    }
    return CreateSecurityRole;
}());
exports.CreateSecurityRole = CreateSecurityRole;
var PermissionNames;
(function (PermissionNames) {
    PermissionNames["CAN_USE_ADMINISTRATIVE_DASHBOARD"] = "Can use administrative dashboard";
    PermissionNames["CAN_EDIT_COMPANY_DETAILS"] = "Can edit company details";
    PermissionNames["CAN_MANAGE_INTEGRATIONS"] = "Can manage integrations";
    PermissionNames["CAN_MANAGE_EMPLOYEES"] = "Can manage employees";
    PermissionNames["CAN_MANAGE_COMPLIANCE_REPORTING"] = "Can manage compliance reporting";
    PermissionNames["CAN_EDIT_PRODUCTS"] = "Can edit products";
    PermissionNames["CAN_VIEW_DISCOUNTS"] = "Can view discounts";
    PermissionNames["CAN_EDIT_DISCOUNTS"] = "Can edit discounts";
    PermissionNames["CAN_EDIT_CATEGORIES"] = "Can edit categories";
    PermissionNames["CAN_VIEW_INVENTORY"] = "Can view inventory";
    PermissionNames["CAN_EDIT_INVENTORY"] = "Can edit inventory";
    PermissionNames["CAN_VIEW_AUDITS"] = "Can view audits";
    PermissionNames["CAN_EDIT_AUDITS"] = "Can edit audits";
    PermissionNames["CAN_VIEW_TRANSFERS"] = "Can view transfers";
    PermissionNames["CAN_EDIT_TRANSFERS"] = "Can edit transfers";
    PermissionNames["CAN_VIEW_VENDORS"] = "Can view vendors";
    PermissionNames["CAN_EDIT_VENDORS"] = "Can edit vendors";
    PermissionNames["CAN_VIEW_BRANDS"] = "Can view brands";
    PermissionNames["CAN_EDIT_BRANDS"] = "Can edit brands";
    PermissionNames["CAN_VIEW_LICENSED_PRODUCERS"] = "Can view licensed producers";
    PermissionNames["CAN_EDIT_LICENSED_PRODUCERS"] = "Can edit licensed producers";
    PermissionNames["CAN_BULK_EDIT_PRODUCTS"] = "Can bulk edit products";
    PermissionNames["CAN_BULK_EDIT_DETAILS_OVERRIDES"] = "Can bulk edit details overrides";
    PermissionNames["CAN_BULK_EDIT_PRICE_OVERRIDES"] = "Can bulk edit price overrides";
    PermissionNames["CAN_MANAGE_WOOCOMMERCE"] = "Can manage WooCommerce";
    PermissionNames["CAN_VIEW_SALES"] = "Can view sales";
    PermissionNames["CAN_EDIT_SALES"] = "Can edit sales";
    PermissionNames["CAN_MANAGE_PARKED_SALES"] = "Can manage parked sales";
    PermissionNames["CAN_VIEW_CUSTOMERS"] = "Can view customers";
    PermissionNames["CAN_ADD_CUSTOMERS"] = "Can add customers";
    PermissionNames["CAN_EDIT_CUSTOMERS"] = "Can edit customers";
    PermissionNames["CAN_VIEW_CUSTOMER_TOTAL_SPEND"] = "Can view customer total spend";
    PermissionNames["CAN_ADJUST_LOYALTY_BALANCE"] = "Can adjust loyalty balance";
    PermissionNames["CAN_MANAGE_OUTREACH"] = "Can manage outreach";
    PermissionNames["CAN_EDIT_LOYALTY_TIERS"] = "Can edit loyalty tiers";
    PermissionNames["CAN_VIEW_LOYALTY_TIERS"] = "Can view loyalty tiers";
    PermissionNames["CAN_VIEW_PURCHASE_ORDERS"] = "Can view purchase orders";
    PermissionNames["CAN_VIEW_REPORTS"] = "Can view reports";
    PermissionNames["CAN_UPDATE_INVENTORY_LOGS"] = "Can update inventory logs";
    PermissionNames["CAN_EDIT_EMPLOYEE_HOURS"] = "Can edit employee hours";
    PermissionNames["CAN_VIEW_BROADCASTS"] = "Can view broadcasts";
    PermissionNames["CAN_EDIT_BROADCASTS"] = "Can edit broadcasts";
    PermissionNames["CAN_START_AND_END_SHIFTS"] = "Can start and end shifts";
    PermissionNames["CAN_ASSIGN_DISCOUNTS"] = "Can assign discounts";
    PermissionNames["CAN_ASSIGN_MANAGER_DISCOUNTS"] = "Can assign manager discounts";
    PermissionNames["CAN_REFUND_SALES"] = "Can refund sales";
    PermissionNames["CAN_PERFORM_NO_SALE"] = "Can perform no sale (iPad only)";
    PermissionNames["CAN_MAKE_NEGATIVE_INVENTORY_SALES"] = "Can make negative inventory sales";
    PermissionNames["CAN_SET_BULK_PRODUCT_PRICES"] = "Can set bulk product prices (web only)";
    PermissionNames["CAN_VIEW_PRICING_TEMPLATES"] = "Can view pricing templates";
    PermissionNames["CAN_EDIT_PRICING_TEMPLATES"] = "Can edit pricing templates";
})(PermissionNames = exports.PermissionNames || (exports.PermissionNames = {}));
var SecurityRole = /** @class */ (function () {
    function SecurityRole() {
    }
    return SecurityRole;
}());
exports.SecurityRole = SecurityRole;
var UpdateSecurityRole = /** @class */ (function () {
    function UpdateSecurityRole() {
    }
    return UpdateSecurityRole;
}());
exports.UpdateSecurityRole = UpdateSecurityRole;
//# sourceMappingURL=SecurityRole.js.map